Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    paginationNumberWidth: 24,
    paginationNumberHeight: 24,
    paginationNumberColorDefault: tokens.themeActionPrimaryDefault,
    paginationNumberColorSelected: tokens.themeInkDefault,
    paginationNumberColorDisabled: tokens.themeInkDisabled,
    paginationNumberSpacingInsetVertical: 2,
    paginationNumberSpacingInsetHorizontal: 8,
    paginationIndicatorBorderWidth: 2,
    paginationIndicatorBorderRadius: 999,
    paginationIndicatorHeight: 4,
    paginationIndicatorColorDefault: tokens.themeDecorativePaletteDefault,
    paginationIndicatorColorHover: tokens.themeActionPrimaryHover,
    paginationIndicatorColorPressed: tokens.themeActionPrimaryPressed,
    paginationArrowColor: tokens.themeDecorativePaletteDefault,
    paginationEllipseWidth: 24,
    paginationEllipseHeight: 14,
    paginationEllipseColorDefault: tokens.themeActionPrimaryDefault,
    paginationEllipseColorDisabled: tokens.themeInkDisabled,
    paginationMotionDuration: "100ms",
    paginationMotionFunction: "ease"
  }
};